// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-carousel__container[data-v-12e33f58]{\r\n\theight: 320px;\n}\n.el-carousel__arrow[data-v-12e33f58]{\r\n\tbackground: none;\r\n\tborder-radius: 0;\r\n\tborder-radius: 50%;\n}\n.el-carousel__arrow[data-v-12e33f58]:hover{\r\n\tbackground:none;\n}\n.el-carousel__arrow i[data-v-12e33f58] {\r\n    cursor: pointer;\r\n    color: #7fd8ce;\r\n    font-size: 2em;\n}\r\n", ""]);
// Exports
module.exports = exports;
